// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadablePaint } from '@confluence/loadable';

export const ForYou = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-OverviewOverview" */ './ForYou/ForYou')).ForYou,
});

export const Recent = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RecentRecent" */ './Recent/Recent')).Recent,
});

export const Starred = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-StarredStarred" */ './Starred/Starred')).Starred,
});

export const Drafts = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DraftsDrafts" */ './Drafts/Drafts')).Drafts,
});

export const Tasks = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TasksTasks" */ './Tasks/Tasks')).Tasks,
});

export { Error } from './Error';
